// It's important for the "relative" class to be applied to the container, and not the inner
// content, so that the absolute positioning of the slider works correctly.
export const container = `
  relative h-full overflow-x-hidden overflow-y-scroll

  group-data-[is-expanded=false]/sidebar:overflow-y-hidden
`;

export const content = `
  p-4 flex flex-col grow h-full overflow-hidden
`;
